import { lazy, Suspense } from "react";
import { useTranslations } from "../../i18n";

// Lazy load Stripe components
const StripeElementsFormComponent = lazy(() =>
  import("./StripeElementsForm").then((module) => ({
    default: module.StripeElementsForm,
  })),
);

import type { TrackingData } from "./StripeElementsForm";

type StripeElementsFormProps = {
  stripePublishableKey: string;
  clientSecret: string;
  bookingIds: string[];
  isRequestBooking: boolean;
  trackingData?: TrackingData;
  onSuccess: (bookingIds: string[]) => void;
  onError: (error: Error) => void;
};

export function StripeElementsFormLazy(props: StripeElementsFormProps) {
  const { t } = useTranslations();
  return (
    <Suspense
      fallback={
        <div className="p-4 text-center text-gray-600">
          {t.cart.paymentFormLoading}
        </div>
      }
    >
      <StripeElementsFormComponent {...props} />
    </Suspense>
  );
}
